var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{attrs:{"bg-color":"white"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"p-10"},[_vm._v(" Sidebar UI Testing ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }